export default {
    path: 'management',
    component: () => import('../Management.vue'),
    children: [
        {
            path: '',
            name: 'Danh sách sản phẩm',
            component: () => import('../table/Table.vue')
        },
        {
            path: 'cu',
            name: 'Tạo sản phẩm',
            component: () => import('../cu/CU.vue'),
        },
        {
            path: 'cu/:id',
            name: 'Chi tiết sản phẩm',
            component: () => import('../cu/CU.vue'),
        },
    ]
};